import React from "react";
import PropTypes from "prop-types";
import { enhanceWithCollapsible } from "../Collapsible/Collapsible";
import StatelessPromotion from "./StatelessPromotion";
import PromotionDescription from "./PromotionDescription";
import classnames from "classnames";

/* TODO: PASS CURRENCY ?? */
function PromotionList({ promotions, layout, initiallyExpanded, currency }) {
  const StatefulPromotionB = enhanceWithCollapsible(StatelessPromotion);
  if (!promotions || promotions.size < 1) {
    return <div />;
  }
  return (
    <div className={classnames("wbkv9-PromotionList", "promotionListContainer")}>
      {promotions.map((promotion, idx) => (
        <StatefulPromotionB
          key={idx}
          promotion={promotion}
          layout={layout}
          currency={currency}
          initiallyExpanded={initiallyExpanded}>
          <PromotionDescription promotion={promotion} />
        </StatefulPromotionB>
      ))}
    </div>
  );
}

PromotionList.propTypes = {
  promotions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default PromotionList;
